import * as React from "react";
import * as style from "./singlePageTemplate.module.scss";
import PropTypes from "prop-types";

export const DataCard = ({ title, children }) => {
  return (
    <div className={style.DataCard}>
      {title && <span className={style.DataCard_title}>{title}</span>}
      <ul>{children}</ul>
    </div>
  );
};

DataCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

DataCard.displayName = "DataCard";

export const DataCardItem = ({
  title,
  children,
  data,
  DataComponent,
  ...rest
}) => {
  return (
    <>
      {data && (
        <li>
          {title && <span className={style.DataCardItem_title}>{title}</span>}
          {data && (
            <DataComponent className={style.DataCardItem_content} {...rest}>
              {data}
            </DataComponent>
          )}
        </li>
      )}
    </>
  );
};

DataCardItem.propTypes = {
  title: PropTypes.string,
  data: PropTypes.node,
  DataComponent: PropTypes.elementType,
};

DataCardItem.defaultProps = {
  DataComponent: "span",
};

DataCardItem.displayName = "DataCardItem";

export const SidebarPaddingBlock = ({ children }) => {
  return <div className={style.SidebarPaddingBlock}>{children}</div>;
};

SidebarPaddingBlock.propTypes = {
  children: PropTypes.node,
};

SidebarPaddingBlock.displayName = "SidebarPaddingBlock";

const SinglePageTemplate = ({
  header,
  sidebar,
  mainContent,
  footer,
  variant,
}) => {
  return (
    <article
      className={`${style.SinglePageTemplate} ${
        variant === "publication" && style.SinglePageTemplate___publication
      }`}
    >
      <header className={style.SinglePageTemplate_header}>{header}</header>
      <aside className={style.SinglePageTemplate_sidebar}>{sidebar}</aside>
      <main className={style.SinglePageTemplate_mainContent}>
        {mainContent}
      </main>
      {footer && (
        <footer className={style.SinglePageTemplate_footer}>{footer}</footer>
      )}
    </article>
  );
};

export default SinglePageTemplate;

SinglePageTemplate.propTypes = {
  header: PropTypes.node,
  sidebar: PropTypes.node,
  mainContent: PropTypes.node,
  footer: PropTypes.node,
  variant: PropTypes.oneOf(["publication"]),
};

SinglePageTemplate.displayName = "SinglePageTemplate";
